import PremiacaoTabela from "@/components/PremiacaoTabela";
import ano2021 from "../assets/premiados2021";
import ano2022 from "../assets/premiados2022";
import ano2023 from "../assets/premiados2023";
import ano2024 from "../assets/premiados2024";
export default {
  name: "Premiacao",
  components: {
    PremiacaoTabela
  },
  data() {
    return {
      ano: 0,
      premiados: {
        ano2021,
        ano2022,
        ano2023,
        ano2024
      }
    };
  }
};